var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErreur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.862 45.203l-13.056-11.603 13.056-11.603c0.659-0.586 0.72-1.597 0.134-2.259s-1.597-0.72-2.259-0.134l-13.337 11.856-13.338-11.856c-0.659-0.586-1.67-0.528-2.259 0.134s-0.528 1.67 0.134 2.259l13.056 11.603-13.056 11.603c-0.659 0.586-0.72 1.597-0.134 2.259 0.317 0.355 0.755 0.538 1.197 0.538 0.378 0 0.758-0.134 1.062-0.403l13.338-11.856 13.337 11.856c0.304 0.272 0.685 0.403 1.062 0.403 0.442 0 0.88-0.182 1.197-0.538 0.586-0.659 0.528-1.67-0.134-2.259z",
    fill: "#CB381F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 64c-8.122 0-15.754-3.162-21.498-8.902s-8.902-13.376-8.902-21.494c0-8.122 3.162-15.754 8.902-21.498s13.376-8.906 21.498-8.906c8.122 0 15.754 3.162 21.498 8.906s8.902 13.376 8.902 21.498c0 8.122-3.162 15.754-8.902 21.494s-13.376 8.902-21.498 8.902zM30.4 6.4c-14.998 0-27.2 12.202-27.2 27.2s12.202 27.2 27.2 27.2c14.998 0 27.2-12.202 27.2-27.2s-12.202-27.2-27.2-27.2z",
    fill: "#CB381F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErreur);
export default __webpack_public_path__ + "static/media/erreur.284648fdc58eb343f5612f0d07d12293.svg";
export { ForwardRef as ReactComponent };